import Vue from "vue";
import Component from "vue-class-component";
import useAuthUser from "@/hooks/useAuthUser";

type HookType = ReturnType<typeof useAuthUser>;

@Component({
  name: "WithAuthUser",
  setup() {
    const {
      authUser,
      authUserStrict,
      userVerified,
      userIsPending,
      userVerificationStatus,
      socialLogin,
      authorities,
      allowAccess,
      setVerificationStatus,
      setSocialLoginStatus,
      updateUser,
    } = useAuthUser();
    return {
      authUser,
      authUserStrict,
      authUserVerified: userVerified,
      authUserIsPending: userIsPending,
      authUserVerificationStatus: userVerificationStatus,
      authUserSocialLogin: socialLogin,
      authUserAuthorities: authorities,
      authUserSetVerificationStatus: setVerificationStatus,
      authUserSetSocialLoginStatus: setSocialLoginStatus,
      authUserUpdate: updateUser,
      authAllowAccess: allowAccess,
    };
  },
})
export default class WithAuthUser extends Vue {
  public authUser!: HookType["authUser"]["value"];
  public authUserStrict!: HookType["authUserStrict"]["value"];
  public authUserVerified!: HookType["userVerified"]["value"];
  public authUserIsPending!: HookType["userIsPending"]["value"];
  public authUserVerificationStatus!: HookType["userVerificationStatus"]["value"];
  public authUserSocialLogin!: HookType["socialLogin"]["value"];
  public authUserAuthorities!: HookType["authorities"]["value"];
  public authAllowAccess!: HookType["allowAccess"]["value"];
  public authUserSetVerificationStatus!: HookType["setVerificationStatus"];
  public authUserSetSocialLoginStatus!: HookType["setSocialLoginStatus"];
  public authUserUpdate!: HookType["updateUser"];
}
